import { gateEnvOptions, getDefaultEnv } from '_lib/env'

export const isFeatureEnabled = (feature, features) => {
  return features?.some((feat) => feat.name === feature && feat.toggle)
}

const ALL_ENV_OPTIONS = [
  { label: 'Production', value: 'prod' },
  { label: 'Development', value: 'dev' },
  { label: 'Staging', value: 'staging' },
]

// Production is only available in production builds. In dev we must never
// surface it in the dropdown nor attempt to connect to production.
export const ENV_OPTIONS = gateEnvOptions(ALL_ENV_OPTIONS)

// Default to Development when available, otherwise the first allowed env.
export const DEFAULT_ENV = getDefaultEnv(ENV_OPTIONS)
